// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getLastChildOfTree = (obj: any) => {
  return obj.firstChild && !obj.firstChild.length ? getLastChildOfTree(obj.firstChild) : obj;
};
